import makeService from './api';

export default makeService('priorities');
